import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';

export const CREDITS_ROUTES = { BALANCE: '/creditos' } as const;

const ENDPOINT = '/api/v1/credits';
const KEY = ['credits'];

export type CreditEntryType = 'TOPUP' | 'USAGE' | 'REFUND' | 'ADJUSTMENT';

export interface CreditEntry {
  id: string;
  type: CreditEntryType;
  amount: number;
  balanceAfter: number;
  description: string;
  createdAt: string;
}

export interface CreditsSummary {
  balance: number;
  messagePrice: number | null;
  messagesLeft: number | null;
  /** Piso da recarga, definido por quem administra o SaaS. */
  minTopUp: number;
  entries: CreditEntry[];
}

export interface CreditsFilter {
  type?: string;
  from?: string;
  to?: string;
}

export function useCredits(filter: CreditsFilter = {}) {
  const busca = new URLSearchParams(
    Object.entries(filter).filter(([, valor]) => Boolean(valor)) as [string, string][],
  ).toString();

  return useQuery({
    queryKey: [...KEY, busca],
    queryFn: () => apiClient.get<CreditsSummary>(busca ? `${ENDPOINT}?${busca}` : ENDPOINT),
  });
}

export function useTopupCredits() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (amount: number) => apiClient.post<CreditsSummary>(`${ENDPOINT}/topup`, { amount }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: KEY }),
  });
}
